import React, { useEffect, useState } from "react";
import { useAppContext } from "../../hooks/AppContext";
import { getAllAndFutureTasks } from "../../services/GraphService/GraphService";
import { useSelector } from "react-redux";
import { SlotsBoard } from "../../features/slots/SlotsBoard";
import dateTimeUtils from "../../utils/DateTimeUtils";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
function getWidth() {
    /*return Math.max(
       document.body.scrollWidth,
       document.documentElement.scrollWidth,
       document.body.offsetWidth,
       document.documentElement.offsetWidth,
       document.documentElement.clientWidth
    )*/
    return document.documentElement.clientWidth;
}
var LIST;
(function (LIST) {
    LIST[LIST["ONE"] = 0] = "ONE";
    LIST[LIST["THREE"] = 1] = "THREE";
    LIST[LIST["FIVE"] = 2] = "FIVE";
})(LIST || (LIST = {}));
export function Plan() {
    const app = useAppContext();
    const [todos, setTodos] = useState();
    const s = useSelector((state) => (state.slots));
    const slots = SlotsBoard.createSlotsBoardFromJson(s);
    useEffect(() => {
        const getTodos = async () => {
            const todos = (await getAllAndFutureTasks(app.authProvider)).filter((t) => {
                return t.getStatus() != 'completed';
            });
            setTodos(todos);
        };
        getTodos();
    }, [slots.updated]);
    const sortedTodos = todos === null || todos === void 0 ? void 0 : todos.sort((a, b) => {
        return a.diff(b);
    });
    // create the X-Axis
    const xAxis = {};
    let max = { 'one': 0, 'three': 0, 'five': 0, 'other': 0 };
    if (sortedTodos != undefined) {
        sortedTodos.forEach((task) => {
            let category = 'other';
            if (task.getCategories().find((c) => c == 'one')) {
                category = 'one';
            }
            else if (task.getCategories().find((c) => c == 'three')) {
                category = 'three';
            }
            else if (task.getCategories().find((c) => c == 'five')) {
                category = 'five';
            }
            if (xAxis[task.getStartDateTime().format('M/D')] == undefined) {
                xAxis[task.getStartDateTime().format('M/D')] = {};
                xAxis[task.getStartDateTime().format('M/D')].dow = task.getStartDateTime().format('ddd');
                xAxis[task.getStartDateTime().format('M/D')][category] = 1;
            }
            else {
                if (xAxis[task.getStartDateTime().format('M/D')][category] == undefined)
                    xAxis[task.getStartDateTime().format('M/D')][category] = 0;
                xAxis[task.getStartDateTime().format('M/D')][category]++;
            }
            max[category] = Math.max(xAxis[task.getStartDateTime().format('M/D')][category], max[category]);
        });
    }
    const width = Object.keys(xAxis).length;
    const height = max['one'] + max['three'] + max['five'] + max['other'] + 1;
    // create the 2 dimensions array
    const grid = [];
    for (let i = 0; i < height; ++i) {
        grid[i] = [];
        for (let j = 0; j < width; ++j) {
            grid[i][j] = { value: null, style: {} };
        }
    }
    let count = 0;
    Object.keys(xAxis).forEach(k => {
        grid[0][count] = { value: k, dow: xAxis[k].dow, style: { backgroundColor: 'grey' } };
        if (dateTimeUtils(undefined).format('M/D') == k) {
            grid[0][count].style = { backgroundColor: 'cyan' };
        }
        count++;
    });
    if (sortedTodos != undefined) {
        sortedTodos.forEach((t) => {
            // find the column to add it to
            const idx = grid[0].findIndex(o => o.value == t.getStartDateTime().format('M/D'));
            if (idx == -1) {
                throw new Error("Logic Error: the timeline contains a key that does not exist");
            }
            // iterate over the column to find a null entry
            let begin = 1;
            switch (t.getCategory()) {
                case 'one':
                    break;
                case 'three':
                    begin = max['one'] + 1;
                    break;
                case 'five':
                    begin = max['one'] + max['three'] + 1;
                    break;
                default:
                    begin = max['one'] + max['three'] + max['five'] + 1;
                    break;
            }
            for (let i = begin; i < height; ++i) {
                if (grid[i][idx].value == null) {
                    let s = {};
                    if (t.getCategories().find((c) => c == 'one')) {
                        s = { backgroundColor: 'primary.main', color: 'primary.contrastText' };
                    }
                    else if (t.getCategory() == 'three') {
                        s = { backgroundColor: 'secondary.main', color: 'secondary.contrastText' };
                    }
                    else if (t.getCategory() == 'five') {
                        s = { backgroundColor: 'warning.main', color: 'warning.contrastText' };
                    }
                    grid[i][idx] = { value: t.getTitle(), style: s };
                    break;
                }
            }
        });
    }
    const header = [];
    const rows = [];
    let i = 0;
    const today = dateTimeUtils(undefined).format('M/D');
    // Find the index of today's column
    const todayColIdx = grid[0].findIndex(c => c.value === today);
    grid.forEach((r, rowIdx) => {
        if (i == 0) {
            r.map((c, colIdx) => {
                let headerStyles = {
                    color: 'white',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    fontSize: '0.85rem'
                };
                if (c.value === today) {
                    headerStyles = Object.assign(Object.assign({}, headerStyles), { backgroundColor: 'primary.dark' });
                }
                else {
                    headerStyles = Object.assign(Object.assign({}, headerStyles), { backgroundColor: 'grey.800' });
                }
                header.push(React.createElement(TableCell, { key: `th-${colIdx}`, sx: headerStyles },
                    React.createElement(Box, { sx: { fontSize: '0.7rem', opacity: 0.8 } }, c.dow || ""),
                    React.createElement(Box, null, c.value || "")));
            });
        }
        else {
            const cells = [];
            r.map((c, colIdx) => {
                let isToday = (todayColIdx !== -1 && colIdx === todayColIdx);
                let cellBg = c.style.backgroundColor;
                let cellColor = c.style.color;
                let cellWrapperStyle = {
                    height: '100%',
                    minHeight: 36,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 1,
                    p: 0.5,
                    fontSize: '0.8rem',
                    fontWeight: isToday ? 'bold' : 'normal',
                    textAlign: 'center',
                    boxSizing: 'border-box'
                };
                if (c.value) {
                    cellWrapperStyle.backgroundColor = cellBg;
                    cellWrapperStyle.color = cellColor;
                    cellWrapperStyle.boxShadow = 1;
                    if (isToday) {
                        cellWrapperStyle.color = 'text.primary';
                        // To make it lighter without alpha function since we use MUI scale names:
                        if (cellBg === 'primary.main')
                            cellWrapperStyle.backgroundColor = 'primary.light';
                        if (cellBg === 'secondary.main')
                            cellWrapperStyle.backgroundColor = 'secondary.light';
                        if (cellBg === 'warning.main')
                            cellWrapperStyle.backgroundColor = 'warning.light';
                    }
                }
                else {
                    if (isToday) {
                        cellWrapperStyle.backgroundColor = 'action.hover';
                    }
                }
                cells.push(React.createElement(TableCell, { key: `td-${colIdx}`, sx: {
                        p: 0.5,
                        borderBottom: 1,
                        borderColor: 'divider',
                        backgroundColor: isToday && !c.value ? 'action.hover' : 'inherit'
                    } }, c.value ? (React.createElement(Box, { sx: cellWrapperStyle }, c.value)) : (React.createElement(Box, { sx: { height: 36, width: '100%' } }))));
            });
            rows.push(React.createElement(TableRow, { key: `tr-${rowIdx}` }, cells));
        }
        i++;
    });
    return (React.createElement(React.Fragment, null, sortedTodos != null &&
        React.createElement(TableContainer, { component: Paper, elevation: 3, sx: { borderRadius: 2, overflow: 'auto', mb: 4, width: '100%' } },
            React.createElement(Table, { size: "small" },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null, header)),
                React.createElement(TableBody, null, rows)))));
}
function union(json1, json2) {
    // Create a new object to store the union of the two JSONs.
    let union = {};
    // Iterate over the properties of the first JSON object.
    for (const key in json1) {
        // If the property does not exist in the second JSON object, add it to the union.
        if (!json2.hasOwnProperty(key)) {
            union[key] = json1[key];
        }
    }
    // Iterate over the properties of the second JSON object.
    for (const key in json2) {
        // If the property does not exist in the first JSON object, add it to the union.
        if (!json1.hasOwnProperty(key)) {
            union[key] = json2[key];
        }
    }
    return union;
}
